import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '@/theme/scalingTokens';

export const usePlannerScreenStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
  },
  hamburger: {
    display: 'none',
    [mq.tablet]: {
      display: 'flex',
      position: 'fixed',
      top: '3.5rem',
      left: tokens.spacingHorizontalS,
      zIndex: 101,
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: tokens.shadow4,
      borderRadius: tokens.borderRadiusMedium,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    paddingTop: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    paddingRight: '0',
    boxSizing: 'border-box',
    overflow: 'auto',
    minWidth: 0,
  },
  title: {
    fontSize: fontScale.title,
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: tokens.spacingVerticalXS,
    color: tokens.colorNeutralForeground1,
  },
  subtitle: {
    fontSize: fontScale.body,
    fontWeight: tokens.fontWeightRegular,
    color: tokens.colorNeutralForeground2,
    marginBottom: tokens.spacingVerticalXXL,
  },
  eventListContent: {
    paddingTop: tokens.spacingVerticalL,
    paddingBottom: tokens.spacingVerticalL,
    paddingLeft: tokens.spacingHorizontalXXL,
    paddingRight: tokens.spacingHorizontalXXL,
    [mq.tablet]: {
      paddingLeft: tokens.spacingHorizontalM,
      paddingRight: tokens.spacingHorizontalM,
    },
  },
  actionBarWrapper: {
    overflow: 'hidden',
    paddingBottom: tokens.spacingVerticalS,
    order: -1,
  },
  actionBarVisible: {
    visibility: 'visible' as const,
  },
  actionBarHidden: {
    visibility: 'hidden' as const,
  },
  gridActionGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
});
